<div class="order-success">
    <div class="container">
        <div class="order-success__body bg-card-new card-radius-x1 mt-5 mb-3">
            <div class="card-body text-center">
                <div class="order-success__subtitle mb-3">
                    {{ 'payment_success' | translate }}
                </div>
                <div class="order-success__icon">
                    <img src="assets/images/success_illustration.png">
                </div>
                <h1 class="order-success__title text-capitalize font-weight-normal">{{ 'thank_you' | translate }}!</h1>
            </div>
        </div>

        <div *ngIf="!isLoading && vendorRequest" class="confirmation-container py-12 px-6 text-center max-w-xl mx-auto bg-card-new card-radius-x1 mb-5">
            <!-- Success Animation / Icon -->
            <div class="mb-8">
                <div class="inline-flex items-center justify-center w-24 h-24 bg-green-100 rounded-full mb-4">
                    <svg class="w-12 h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                </div>
            </div>

            <!-- Confirmation Heading -->
            <h2 class="text-2xl font-bold text-green-600 mb-4">
                {{ 'welcome_aboard' | translate }}
            </h2>
            <p class="text-gray-900 text-base mb-3 font-medium leading-relaxed">
                {{ 'thank_you_subscription_message' | translate }}
            </p>
            <p class="text-gray-600 mb-8 leading-relaxed">
                {{ 'subscription_active_message' | translate }}
            </p>

            <!-- Order Summary Card -->
            <div class="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden text-left mb-8">
                <div class="bg-gray-50 p-6 border-b border-gray-200">
                    <h3 class="text-lg font-semibold text-gray-900 flex items-center gap-2">
                        <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        {{ 'subscription_details' | translate }}
                    </h3>
                </div>
                <div class="p-6 space-y-4 text-sm">
                    <div class="flex justify-between items-center" *ngIf="!isCustomer">
                        <span class="text-gray-600">{{ 'company_name' | translate }}:</span>
                        <span class="font-semibold text-gray-900">{{ vendorRequest?.companyName }}</span>
                    </div>
                    <div class="flex justify-between items-center">
                        <span class="text-gray-600">{{ 'email' | translate }}:</span>
                        <span class="font-semibold text-gray-900">{{ vendorRequest?.email }}</span>
                    </div>
                    <div *ngIf="selectedPlan" class="flex justify-between items-center pt-4 border-t border-gray-200">
                        <span class="text-gray-600">{{ 'selected_plan' | translate }}:</span>
                        <span class="font-semibold text-gray-900">{{ translateHelper.localize(selectedPlan?.name) }}</span>
                    </div>
                    <div *ngIf="selectedPlan" class="flex justify-between items-center">
                        <span class="text-gray-600">{{ 'billing_cycle' | translate }}:</span>
                        <span class="font-semibold text-gray-900">{{ getPlanDuration() | translate }}</span>
                    </div>
                    <div *ngIf="selectedPlan" class="flex justify-between items-center pb-4 border-b border-gray-200">
                        <span class="text-gray-600">{{ 'amount_paid' | translate }}:</span>
                        <span class="font-semibold text-green-600 text-lg">{{ getPlanPrice() }} {{ selectedPlan?.currency?.en || 'BHD' }}</span>
                    </div>
                    <div class="flex justify-between items-center">
                        <span class="text-gray-600">{{ 'status' | translate }}:</span>
                        <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                            <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                            </svg>
                            {{ 'active' | translate }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Go to Dashboard Button -->
            <div class="mt-8">
                <button type="button" class="btn btn-primary px-10 py-3 text-base font-semibold shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2 mx-auto" (click)="goToSubscriptionManagement()">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                    </svg>
                    <span>{{ 'manage_subscription' | translate }}</span>
                </button>
            </div>
        </div>

        <div *ngIf="isLoading" class="text-center py-12">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">{{ 'loading' | translate }}...</span>
            </div>
        </div>
    </div>
</div>
